export default {
  first_name: '',
  last_name: '',
  email_address: '',
  mobile_no: '',
  nrc_number: '',
  tpin_number: '',
  bid_amount: '',
  location: '',
  province: {
    text: '',
    value: ''
  },
  city: {
    text: '',
    value: ''
  },
  vehicle_reg: '',
  year_of_manf: '',
  vehicle_make: '',
  vehicle_model: ''  
}